import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import withRouter from '../../components/Common/withRouter';
import { Card, CardBody, Col, Container, Row, Table, Button } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import VerticalLayout from '../../components/VerticalLayout';
import { useAuthStore } from '../../zustand-store/auth.store';
import { ROLES } from '../../constants/layout';
const TodayBookings = () => {
  document.title = 'Reports | Seamless Slot';
  const { role } = useAuthStore((state) => state);
  const navigate = useNavigate();

  const ContactsProperties = createSelector(
    (state) => state.contacts,
    (Contacts) => ({
      users: Contacts?.users,
      loading: Contacts?.loading
    })
  );

  const { loading } = useSelector(ContactsProperties);
  const [isLoading] = useState(loading);

  // Mock reports list (replace with API data)
  const [reports] = useState([
    {
      id: 1,
      title: 'Appointments Report',
      route: '/reports/todayBookingsReport',
      show:
        role === ROLES.BUSINESS_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN
    },
    {
      id: 2,
      title: 'SMS and Email Report',
      route: '/reports/smsemailreport',
      show:
        role === ROLES.BUSINESS_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN
    },
    {
      id: 3,
      title: 'All Time Revenue Report',
      route: '/reports/revenuereport',
      show:
        role === ROLES.BUSINESS_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN
    },
    {
      id: 4,
      title: 'All Time App fees',
      route: '/reports/alltimefees',
      show:
        role === ROLES.BUSINESS_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN
    },
    {
      id: 5,
      title: 'Complete Payment Log',//Payment History, All Transactions, Payment Ledger
      route: '/reports/completepaymentlog',
      show:
        role === ROLES.BUSINESS_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN
    },
    {
      id: 6,
      title: 'Dentally Report',
      route: '/reports/dentallyreport',
      show:
        role === ROLES.BUSINESS_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN
    },
    {
      id: 7,
      title: 'Audit Log Report',
      route: '/reports/auditlogs',
      show: role === ROLES.SUPER_ADMIN
    }
  ]);

  useEffect(() => {
    localStorage.setItem('path', '/reports');
  }, []);

  return (
    <VerticalLayout>
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* <Breadcrumbs title="Reports" breadcrumbItem="Reports" /> */}
            <div className="d-flex justify-content-between align-items-center w-100" style={{marginBottom:20}}>
                {/* Left side */}
                <p style={{ fontSize: '16px', fontWeight: 500, color: '#000', margin: 0 }}>
                Reports
                </p>

                {/* Right side */}
                <div className="d-flex align-items-center gap-3">
            
     
          
                 
                </div>
              </div>
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <h4 className="mb-4">Reports List</h4>
                      <Table bordered striped>
                        <thead>
                          <tr>
                            <th>Title</th>

                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports
                            .filter((report) => report.show)
                            .map((report, index) => (
                              <tr key={report.id + index}>
                                <td>{report.title}</td>

                                <td className="text-end">
                                  <Button color="white" onClick={() => navigate(report.route)}>
                                    View
                                  </Button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </Container>
        </div>
        <ToastContainer />
      </React.Fragment>
    </VerticalLayout>
  );
};

export default withRouter(TodayBookings);
